import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { map } from 'rxjs/operators';

import { BotMessage, Message } from 'src/app/chat-ai/models/chat-ai.models';
import { CHAT_AI_COMPONENT_CONFIG, IChatAiComponentConfig } from 'src/app/chat-ai/models/chat-ai-config.models';
import { ChatAiDemoApiService } from 'src/app/chat-ai/services/api/demo/chat-ai-demo-api.service';
import { ChatAiStorageService } from 'src/app/chat-ai/services/storage/chat-ai-storage.service';

export const getInitMessagesResolver: ResolveFn<Message[]> = (route, state) => {
    const storageService: ChatAiStorageService = inject(ChatAiStorageService);
    const messages: Message[] = storageService.getMessages();
    if (messages.length) {
        return messages;
    }

    const config: IChatAiComponentConfig = inject(CHAT_AI_COMPONENT_CONFIG);
    if (!config.shouldLoadDefaultMessage) {
        return [];
    }

    return inject(ChatAiDemoApiService)
        .getBotResponse(undefined)
        .pipe(map(text => [new BotMessage(text)]));
};
